import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { apiUrl } from '../config/api';

function CreateUserForm({ onClose, onSuccess }: { onClose: () => void; onSuccess: () => void }) {
  const token = useSelector((state: RootState) => state.auth.token);

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('user');
  const [employedSince, setEmployedSince] = useState(() => new Date().toISOString().slice(0, 10));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCreate = async () => {
    const confirmed = window.confirm('Willst du diesen neuen Nutzer wirklich anlegen?');
    if (!confirmed) return;

    setLoading(true);
    setError('');

    try {
      const res = await fetch(apiUrl('/api/users'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ username, email, password, role, employedSince }),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Fehler beim Erstellen');
      }

      alert('Benutzer erfolgreich erstellt.');
      onSuccess();
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="card p-4 shadow-sm" style={{ maxWidth: 400, margin: 'auto' }}>
        <h4 className="mb-3">Neuen Nutzer anlegen</h4>

        {error && <div className="alert alert-danger">{error}</div>}

        <input
          className="form-control mb-2"
          placeholder="Benutzername"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          disabled={loading}
        />
        <input
          className="form-control mb-2"
          placeholder="E-Mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
        />
        <input
          className="form-control mb-2"
          type="password"
          placeholder="Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={loading}
        />
        <select
          className="form-select mb-3"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          disabled={loading}
        >
          <option value="user">User</option>
          <option value="admin">Admin</option>
        </select>
        <label className="form-label">Beschäftigt seit</label>
        <input
          className="form-control mb-3"
          type="date"
          value={employedSince}
          onChange={(e) => setEmployedSince(e.target.value)}
          disabled={loading}
        />

        <div className="d-flex justify-content-between">
          <button className="btn btn-secondary" onClick={onClose} disabled={loading}>
            Abbrechen
          </button>
          <button className="btn btn-primary" onClick={handleCreate} disabled={loading}>
            {loading ? 'Erstelle...' : 'Erstellen'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateUserForm;
